import { useTranslation } from 'react-i18next';
import { ButtonSecondary } from '@components/button';
import { IconCaret } from '@components/icons';
import classNames from 'classnames';

export const ButtonExpand = ({
  setIsSummaryExpanded,
  isSummaryExpanded,
  isVisible,
}: {
  setIsSummaryExpanded: (val: boolean) => void;
  isSummaryExpanded: boolean;
  isVisible: boolean;
}) => {
  const { t } = useTranslation();
  if (!isVisible) return;
  return (
    <ButtonSecondary
      className={classNames('w-full my-3')}
      onClick={() => setIsSummaryExpanded(!isSummaryExpanded)}
      type='button'>
      <span>{isSummaryExpanded ? t('common:hide') : t('common:show')}</span>
      <IconCaret
        className={classNames('w-4 h-4 ml-2 transition-all', {
          '-rotate-90': isSummaryExpanded,
          'rotate-90': !isSummaryExpanded,
        })}
      />
    </ButtonSecondary>
  );
};
